import { useClerk } from '@clerk/clerk-react';

function PendingApproval() {
  const { signOut } = useClerk();
  return (
    <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '100vh', backgroundColor: '#FAFAF8', fontFamily: '-apple-system, BlinkMacSystemFont, "Segoe UI", sans-serif' }}>
      <div style={{ backgroundColor: '#fff', border: '0.5px solid #E8E4E0', borderRadius: '12px', padding: '2.5rem', maxWidth: '420px', textAlign: 'center' }}>
        <h1 style={{ fontSize: '1.2rem', fontWeight: '500', color: '#1A1A1A', margin: '0 0 0.75rem' }}>Account pending approval</h1>
        <p style={{ fontSize: '0.875rem', color: '#888', margin: '0 0 1.5rem', lineHeight: '1.6' }}>Your account is pending approval. Contact your administrator.</p>
        <button onClick={() => signOut()} style={{ fontSize: '0.875rem', color: '#4A5568', background: 'none', border: '1px solid #D4CFC9', borderRadius: '6px', padding: '0.5rem 1.25rem', cursor: 'pointer' }}>Sign out</button>
      </div>
    </div>
  );
}

export default PendingApproval;
